import { useEffect, useState } from 'preact/hooks';
import PropTypes from 'prop-types';

export const VideoSection = ({ link }) => {

  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowVideo(true);
    }, 800);
  }, []);

  return (
    <>
      {
        !showVideo ? <div className="videoWrapper"><div className="check-animation"></div></div> : <div className="videoWrapper"><video autoplay muted playsinline preload="none" className="check-animation">
          <source src={link} type="video/mp4" />
        </video></div>
      }
    </>
  )
}

VideoSection.propTypes = {
  link: PropTypes.string.isRequired
};